import { useSettings } from '@backpackjs/storefront';
import { GpcBanner } from './GpcBanner';

export function Pandectes() {
  const settings = useSettings();
  const globalPandectesSettings = settings?.pandectes || {};

  const {
    gpcBannerEnabled = false,
    gpcBannerGpcEnabled = false,
    gpcBannerDntEnabled = false,
    gpcBannerText = 'We respect your Global Privacy Control (GPC) signal and automatically opt you out of non-essential cookies and data sharing.',
    gpcBannerColor = '#CCE0F1',
  } = globalPandectesSettings;

  if (!gpcBannerEnabled) return null;

  return (
    <pandectes>
      <GpcBanner
        text={gpcBannerText}
        backgroundColor={gpcBannerColor}
        gpcBannerDntEnabled={gpcBannerDntEnabled}
        gpcBannerGpcEnabled={gpcBannerGpcEnabled}
      />
    </pandectes>
  );
}

Pandectes.displayName = 'Pandectes';
